import { MerchantStructure } from '@nemuru-eng/js-api-client';
import React from 'react';

import { HeaderCard } from './HeaderCard';

export const MerchantHeaderCard: React.FC<{ merchantStructure: MerchantStructure }> = ({ merchantStructure }) => {
  return (
    <HeaderCard
      type={'merchant'}
      title={merchantStructure.merchant.businessName}
      iconName={'corporate_fare'}
      copyToClipboard={{ value: merchantStructure.merchant.id, textId: 'COPY_MERCHANT_ID' }}
    />
  );
};
